// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `svg.ds-icon {
    width: 16px;
    height: 16px;
    fill: currentColor;
}

svg.ds-icon--large {
    width: 24px;
    height: 24px;
    fill: currentColor;
}

svg.ds-icon--flipped {
    transform: scale(-1, 1);
}

/* Pulled directly from FA */
svg.ds-icon--spin {
    -webkit-animation: fa-spin 2s infinite linear;
            animation: fa-spin 2s infinite linear; }

svg.ds-icon--pulse {
    -webkit-animation: fa-spin 1s infinite steps(8);
            animation: fa-spin 1s infinite steps(8); }

@-webkit-keyframes fa-spin {
    0% {
      -webkit-transform: rotate(0deg);
              transform: rotate(0deg); }
    100% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg); } }

@keyframes fa-spin {
    0% {
      -webkit-transform: rotate(0deg);
              transform: rotate(0deg); }
    100% {
      -webkit-transform: rotate(360deg);
              transform: rotate(360deg); } }`, "",{"version":3,"sources":["webpack://./node_modules/@ellucian/ds-icons/lib/Icon/Icon.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,4BAA4B;AAC5B;IACI,6CAA6C;YACrC,qCAAqC,EAAE;;AAEnD;IACI,+CAA+C;YACvC,uCAAuC,EAAE;;AAErD;IACI;MACE,+BAA+B;cACvB,uBAAuB,EAAE;IACnC;MACE,iCAAiC;cACzB,yBAAyB,EAAE,EAAE;;AAE3C;IACI;MACE,+BAA+B;cACvB,uBAAuB,EAAE;IACnC;MACE,iCAAiC;cACzB,yBAAyB,EAAE,EAAE","sourcesContent":["svg.ds-icon {\n    width: 16px;\n    height: 16px;\n    fill: currentColor;\n}\n\nsvg.ds-icon--large {\n    width: 24px;\n    height: 24px;\n    fill: currentColor;\n}\n\nsvg.ds-icon--flipped {\n    transform: scale(-1, 1);\n}\n\n/* Pulled directly from FA */\nsvg.ds-icon--spin {\n    -webkit-animation: fa-spin 2s infinite linear;\n            animation: fa-spin 2s infinite linear; }\n\nsvg.ds-icon--pulse {\n    -webkit-animation: fa-spin 1s infinite steps(8);\n            animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n              transform: rotate(0deg); }\n    100% {\n      -webkit-transform: rotate(360deg);\n              transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n              transform: rotate(0deg); }\n    100% {\n      -webkit-transform: rotate(360deg);\n              transform: rotate(360deg); } }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
